<template>
  <div class="course-container">
    <van-nav-bar :title="title" @click-left="leftFn" left-arrow>
      <template
        v-if="courseInfo.courseType && courseInfo.courseType == 1"
        #right
      >
        <div class="coursetest" @click="getCourse">课程测评</div>
      </template>
    </van-nav-bar>
    <van-list
      v-show="showSecondContent"
      ref="listContent"
      v-model="loading"
      :finished="finished"
      :immediate-check="true"
      finished-text="没有数据了哦！"
      @load="loadMore"
    >
      <second-step
        :showVideoPng="showVideoPng"
        :contentList="contentList"
        :showContent="showSecondContent"
      />
    </van-list>
  </div>
</template>

<script>
import { decryptBy } from "@/assets/js/encryption";
import SecondStep from "@/components/parent-course/second-step.vue";
import { course } from "@/api/parent-course";
import { courseQuestionnaireList } from "@/api/test-center";
export default {
  components: { SecondStep },
  data() {
    return {
      loading: true,
      finished: false,
      showSecondContent: true,

      courseParams: {
        asc: false,
        currentPage: 1,
        pageSize: 5,
        queryData: {
          courseId: "",
          putaway: false,
        },
      },
      showVideoPng: false,
      contentList: [],

      courseInfo: {},
    };
  },

  // 计算属性
  computed: {
    title() {
      return this.courseInfo.title;
    },
  },

  // 数据监听
  watch: {},

  // 自定义方法
  methods: {
    //课程测评问卷量表打开
    getCourse() {
      let parentInfos = localStorage.getItem("userInfo");
      let resultParent = JSON.parse(decryptBy(parentInfos));
      courseQuestionnaireList({
        asc: false,
        currentPage: 1,
        orderByField: "",
        pageSize: 9999,
        queryData: {
          ids: [],
          userId: "",
          courseId: this.courseInfo.id,
          childId: localStorage.getItem("childId"),
          parentId: resultParent.userId,
        },
      }).then((res) => {
        if (res.code == 200 && res.data) {
          let list = res.data.records;
          this.$router.push({
            path: "/test",
            query: {
              type: 3, //数据来源：2、儿童测试 3、家长测试
              title: list[0].questionnaireName, // 量表名称
              key: list[0].questionnaireId, //量表的key
              projectUrl: list[0].questionnaireUrl, // 量表地址
            },
          });
        }
      });
    },
    leftFn() {
      if (this.$router.app._route.query.sourceType) {
        this.$router.push("/");
      } else {
        this.$router.back();
      }
    },
    // 获取课程详情
    async course() {
      this.loading = true;
      try {
        let res = await course(this.courseParams);
        if (res.code == 200 && res.data) {
          res = res.data;
          this.contentList = this.contentList.concat(res.records);
          if (res.total == this.contentList.length) {
            this.finished = true;
          }
        }
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },

    loadMore() {
      this.courseParams.currentPage++;
      this.course();
    },
  },

  // 刚创建vue实例完毕
  created() {
    this.courseInfo = this.$storage.getStore("courseInfo");
    this.courseParams.queryData.courseId = this.$route.params.id;
    this.course();
  },

  // 刚挂载完毕
  mounted() {},
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.course-container {
  min-height: 100vh;
  background-color: #f5f7fa;
  .coursetest {
    width: 67px;
    height: 28px;
    background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
    border-radius: 14px;
    text-align: center;
    line-height: 28px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
  .van-list {
    padding: 8px 20px 0 20px;
  }
}
</style>
